module.exports = __webpack_public_path__ + "static/media/school-button.0bf352d8.png";